import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import Input from "../../../Components/Input";
import Select from "../../../Components/Select";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AlertModel from "../../../Components/AlertModel";

const BuyAssets = ({
  localFormState,
  assetFormState,
  setAssetFormState,
  pageType,
  viewFormOptions,
}) => {
  const dispatch = useDispatch();
  const [alertModel, setAlertModel] = useState(false);
  // asset form state
  const editState = useSelector(
    (state) => state?.financeReducer?.editAssetFormState
  );
  const setEditState = (state) =>
    dispatch(
      actions?.setFormState({
        formName: "editAssetFormState",
        formState: state,
      })
    );

  const addAssetData = useSelector(
    (state) => state?.financeReducer?.addAssetData
  );
  const buyAssetData = useSelector(
    (state) => state?.financeReducer?.buyAssetData
  );

  const prefix = addAssetData?.data?.prefix;
  console.log(prefix, "prefix");
  const addEditDefaultValue = {
    payee_id: localFormState?.payee_id,
    assetId: localFormState?.asset_account_id,
    unrealized_pl: "",
    name: "",
    opening_balance: "",
    purchase_value: "",
    salvage_value: "",
    useful_life: "",
    default_deposit_account_id: "",
  };
  const schema = yup.object().shape({
    payee_id: yup.string(),
    assetId: yup.string(),
    unrealized_pl: yup.string(),
    name: yup.string(),
    opening_balance: yup.string(),
    purchase_value: yup.string(),
    salvage_value: yup.string(),
    useful_life: yup.string(),
    default_deposit_account_id: yup.string(),
  });
  const {
    register: assetRegister,
    formState: { errors: assetErrors },
    handleSubmit: assetHandleSubmit,
    reset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: addEditDefaultValue,
  });

  function getForm(prefix) {
    switch (prefix) {
      case "A04":
      case "A07":
        return (
          <>
            <Input
              label={"Investment Name"}
              formRegister={assetRegister}
              formError={assetErrors}
              formKey={"name"}
            />
            <Input
              label={"Unrealized P&L"}
              formRegister={assetRegister}
              formError={assetErrors}
              formKey={"unrealized_pl"}
            />
          </>
        );

      case "A06":
        return (
          <>
            <Input
              label={"Deposit Name"}
              formRegister={assetRegister}
              formError={assetErrors}
              formKey={"name"}
            />
            <Input
              label={"Deposit Amount"}
              formRegister={assetRegister}
              formError={assetErrors}
              formKey={"opening_balance"}
            />
          </>
        );

      case "A05":
        return (
          <>
            <Input
              label={"Asset Name"}
              formRegister={assetRegister}
              formError={assetErrors}
              formKey={"name"}
            />
            <Input
              label={"Purchase Value"}
              formRegister={assetRegister}
              formError={assetErrors}
              formKey={"purchase_value"}
            />
            <Input
              label={"Salvage Value"}
              formRegister={assetRegister}
              formError={assetErrors}
              formKey={"salvage_value"}
            />
            <Input
              label={"Useful Life of Asset (Years)"}
              formRegister={assetRegister}
              formError={assetErrors}
              formKey={"useful_life"}
            />
            <Select
              label={"Default payment account"}
              formRegister={assetRegister}
              formError={assetErrors}
              formKey={"default_deposit_account_id"}
              optionsArray={addAssetData?.adhocs}
            />
          </>
        );
    }
  }

  function submitData(data) {
    console.log("dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", data);
    if (editState)
      dispatch(
        actions.postAddAssetData({
          ...data,
          payee_id: localFormState?.payee_id,
          assetId: localFormState?.asset_account_id,
        })
      );
    else dispatch(actions.postAddAssetData(data));
  }
  useEffect(() => {
    reset(addEditDefaultValue);
  }, [localFormState]);

  function handleEdit(key) {
    if (!localFormState?.asset_account_id) {
      setAlertModel(true);
      return;
    }

    dispatch(
      actions?.getAddAssetData({
        asset_account_id: localFormState?.asset_account_id,
      })
    );
    const editValue = buyAssetData?.allAssets?.find((el) => el?.key === key);
    console.log(key, editValue, "keykey");
    reset(editValue);
    setEditState(true);
  }

  function getHtml(pageType) {
    if (pageType === "viewPayment") {
      return <></>;
    }

    return (
      <tbody>
        {buyAssetData?.allAssets?.map((el, idx) => (
          <tr>
            <td>{idx + 1}</td>
            <td>{idx}</td>
            <td>{idx}</td>
            <td>
              <a
                onClick={() => {
                  handleEdit(el.key);
                }}
                class="circle_icon edit_asset"
              >
                <i class="iconSprites edit-icon">
                  <div class="tooltip-sm"> Edit </div>{" "}
                </i>
              </a>
              <a
                onClick={() => {
                  console.log(el);

                  dispatch(
                    actions?.postDeleteAddAssetData({
                      payee_id: el?.payee_id,
                      assetId: el?.assetId,
                      id: el?.key,
                    })
                  );
                  dispatch(
                    actions?.getAddAssetData({
                      asset_account_id: localFormState?.asset_account_id,
                    })
                  );
                }}
                class="circle_icon delete_asset"
              >
                <i class="iconSprites delete-icon">
                  <div class="tooltip-sm"> delete </div>{" "}
                </i>
              </a>
            </td>
          </tr>
        ))}
      </tbody>
    );
  }
  console.log(!(assetFormState || editState), "!(assetFormState || editState)");
  return (
    <div className="shadowclass mt-4 d-flex flex-wrap align-content-start p-4">
      <h4 className="event-alert w-100 mb-0">
        {assetFormState ? "New Asset" : editState ? "Edit Asset" : "Assets"}
      </h4>
      {!(assetFormState || editState) ? (
        <div className="row col-12 mx-0">
          <table className="checklist-table remove-space inventory_table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Date/Time</th>
                <th>Purchase Price</th>
                <th>Action</th>
              </tr>
            </thead>
            {getHtml(pageType)}
          </table>
          <button
            onClick={() => {
              if (!localFormState?.asset_account_id) {
                setAlertModel(true);
                return;
              }
              dispatch(
                actions?.getAddAssetData({
                  asset_account_id: localFormState?.asset_account_id,
                })
              );
              setAssetFormState(true);
              reset(addEditDefaultValue);
            }}
            class="btn green-btn-revert add-plus add_asset col-md-2"
            type="button"
          >
            <i class="i-icon"> </i> Add Asset
          </button>
        </div>
      ) : (
        <div className="row col-12 mx-0">
          <div className="settings-right-content scrolling px-0 pt-3">
            <form onSubmit={assetHandleSubmit(submitData)}>
              {console.log(assetErrors, "assetErrors")}
              <div className="date-sec-scroll">
                <div
                  id="MenuItemInfo"
                  className="row-fluid scroll-change full_div"
                  day_time="Address"
                >
                  <div className="">
                    <ul class="ingredient-info edit-shift">
                      <Select
                        label={"Select Account"}
                        formRegister={assetRegister}
                        formError={assetErrors}
                        formKey={"parent_finance_account_id"}
                        optionsArray={addAssetData?.subAccounts}
                      />
                      {getForm(prefix)}
                    </ul>
                  </div>
                </div>
                <div class="btns col-4 d-flex justify-content-end py-4 col-12">
                  <button
                    onClick={() => {
                      setAssetFormState(false);
                      setEditState(false);
                    }}
                    id="cancel"
                    type="button"
                  >
                    Cancel
                  </button>
                  <input
                    onClick={(e) => {
                      console.log(assetErrors, getValues());
                      // e.preventDefault();
                    }}
                    type="submit"
                    value="Submit"
                  />
                  {/* <button onClick={(e) => e.preventDefault()} type="submit"> */}
                  {/* Submit */}
                  {/* </button> */}
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      <AlertModel
        title="Alert"
        text="Please select a asset account."
        open={alertModel}
        closeModal={setAlertModel}
      />
    </div>
  );
};

export default BuyAssets;
